// removed by extract-text-webpack-plugin
module.exports = {"saveButton":"actions-panel__saveButton-1yqQx blocks__huge-2XOet blocks__green-2w7kK blocks__button-1iODk","cancelButton":"actions-panel__cancelButton-3zydw blocks__huge-2XOet blocks__white-2DChO blocks__button-1iODk"};


//////////////////
// WEBPACK FOOTER
// ./components/common/user/user-form/actions-panel/actions-panel.css
// module id = 830
// module chunks = 0